import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// iOS PWA keyboard fit: interactive-widget=resizes-content already shrinks the layout above the
// keyboard, BUT iOS keeps reporting env(safe-area-inset-bottom) ≈ 34px (home indicator) even when
// the keyboard covers that area — leaving a dead gap under the composer. We can't sense the
// keyboard in pure CSS, so flag .kb-open when the visible viewport shrinks well below its resting
// height; the CSS then drops the safe-area padding. We DON'T touch layout height (binding it to a
// mid-animation visualViewport value bounced the composer to the top — avoid).
function setupKeyboardFit(): void {
  const vv = window.visualViewport;
  if (!vv) return;
  let restH = vv.height; // tallest seen = keyboard-closed height
  const root = document.documentElement;
  const upd = () => {
    restH = Math.max(restH, vv.height);
    root.classList.toggle('kb-open', restH - vv.height > 120);
  };
  vv.addEventListener('resize', upd);
  vv.addEventListener('scroll', upd);
  upd();
}
setupKeyboardFit();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
